import { contentTags } from "../shared/grailConstants";
import { StringFormCombobox } from "@/components/forms/FormCombobox";

interface ContentTagSelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  value?: string | null;
}

export default function ContentTagSelect(props: ContentTagSelectProps) {
  const { isErrored, onChange, readOnly, value, required } = props;

  return (
    <StringFormCombobox
      id="content-tag-select"
      options={contentTags}
      value={value}
      onChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      isErrored={isErrored}
      autoComplete="new-password"
      creatable={{
        // Create only via this row (or Enter while highlighted). Blur reverts —
        // see StringFormCombobox close policy (clearOnBlur).
        // `match: "includes"`: no creatable row when a constant already contains
        // the query (avoids "asm" + "ASMR" both appearing).
        formatLabel: (query) => query,
        toValue: (query) => query,
        match: "includes",
      }}
    />
  );
}
